//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('timeCustomersWo', {
//        templateUrl: 'views/components/views/timeCustomersWo/timeCustomersWo.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'timeCustomersWoService', function ($stateParams, timeCustomersWoService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let custNo = $stateParams.cust_no;

//            vm.model = {
//                itemsListTimeCustomersWo: []
//            };

//		    // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadTimeCustomersWos() {
//                vm.model.itemsListTimeCustomersWo = await timeCustomersWoService.listTimeCustomersWos({
//                    cust_name: 'ALL',
//                    cust_no: custNo,
//                    project_keyno: '0',
//                    ok: '0'
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadTimeCustomersWos();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
